"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    acceptInvite: {
        path: "/accept-invite/:inviteId"
    },
    passwordReset: {
        path: "/password-reset"
    },
    passwordResetRequest: {
        path: "/password-reset/:requestId"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvdXNlcnMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBhY2NlcHRJbnZpdGU6IHtcbiAgICBwYXRoOiBcIi9hY2NlcHQtaW52aXRlLzppbnZpdGVJZFwiLFxuICB9LFxuICBwYXNzd29yZFJlc2V0OiB7XG4gICAgcGF0aDogXCIvcGFzc3dvcmQtcmVzZXRcIixcbiAgfSxcbiAgcGFzc3dvcmRSZXNldFJlcXVlc3Q6IHtcbiAgICBwYXRoOiBcIi9wYXNzd29yZC1yZXNldC86cmVxdWVzdElkXCIsXG4gIH0sXG59KTtcbiJdLCJuYW1lcyI6WyJyb3V0ZXMiLCJidWlsZFJvdXRlcyIsImFjY2VwdEludml0ZSIsInBhdGgiLCJwYXNzd29yZFJlc2V0IiwicGFzc3dvcmRSZXNldFJlcXVlc3QiXSwibWFwcGluZ3MiOiI7Ozs7K0JBRWFBOzs7ZUFBQUE7Ozt1QkFGZTtBQUVyQixNQUFNQSxTQUFTQyxJQUFBQSxrQkFBVyxFQUFDO0lBQ2hDQyxjQUFjO1FBQ1pDLE1BQU07SUFDUjtJQUNBQyxlQUFlO1FBQ2JELE1BQU07SUFDUjtJQUNBRSxzQkFBc0I7UUFDcEJGLE1BQU07SUFDUjtBQUNGIn0=